<!-- BEGIN PRELOADER -->
<div *ngIf="loadingOverlay" (click)="loadingOverlay = false;" class="loader-overlay" style="opacity: 0.8;">
    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
<!-- END PRELOADER -->

<div class="header">
    <h2>Rapporto di <strong>Ispezione</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a style="cursor: pointer;" [routerLink]="['/inspection']">Ispezioni</a></li>
            <li class="active">Rapporto di Ispezione</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-lg-12 portlets">
        <div class="panel">
            <div class="panel-content">
                <form #inspectionValidationForm="ngForm" role="form" class="form-horizontal form-validation">
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-sm-6">
                            <div class="panel">
                                <div class="panel-header bg-dark">
                                    <span style="text-transform: uppercase;"><i class="fa fa-briefcase"></i>Dettagli <strong>Ispezione</strong></span>
                                </div>
                                <div class="panel-content" style="padding-top: 33px; padding-bottom: 33px;">
                                    <div class="form-group">
                                        <label for="contract" class="col-sm-4 control-label">Convenzione *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="contract"
                                                   class="form-control-plaintext"
                                                   [value]="inspection.contract.name"
                                                   readonly>
                                            <i class="fa fa-file-text"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="contract_founder" class="col-sm-4 control-label">Fornitore *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="contract_founder"
                                                   class="form-control-plaintext"
                                                   [value]="inspection.contract.contract_founder.name"
                                                   readonly>
                                            <i class="fa fa-file-text"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="pa" class="col-sm-4 control-label">Ragione Sociale PA *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="pa"
                                                   class="form-control-plaintext"
                                                   [value]="inspection.pa.name"
                                                   readonly>
                                            <i class="fa fa-file-text"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="date_inspection" class="col-sm-4 control-label">Data Ispezione *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input matInput
                                                   [matDatepicker]="dateStartPicker"
                                                   id="date_inspection"
                                                   name="date_inspection"
                                                   class="form-control"
                                                   data-lang="it"
                                                   data-autoclose="true"
                                                   data-orientation="bottom left"
                                                   autocomplete="off"
                                                   placeholder="Inserisci Data Ispezione (gg/mm/aaaa)..."
                                                   required
                                                   [ngClass]="{
                                            'form-success': inspection.date_inspection !== null
                                       }"
                                                   [(ngModel)]="inspection.date_inspection"
                                                   [disabled]="inspection.fk_id_inspection_state === 6"
                                                   (click)="dateStartPicker.open()">
                                            <i class="icon-calendar"></i>
                                            <mat-datepicker #dateStartPicker></mat-datepicker>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="start_hour" class="col-sm-4 control-label">Ora Inizio Ispezione *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="start_hour"
                                                   name="start_hour"
                                                   class="form-control"
                                                   placeholder="Inserisci Ora Inizio Ispezione..."
                                                   minlength="4"
                                                   required
                                                   autocomplete="off"
                                                   [ngClass]="{
                                            'form-error': !(start_hour.valid || start_hour.pristine),
                                            'form-success': start_hour.valid
                                       }"
                                                   [(ngModel)]="inspection.start_hour"
                                                   [disabled]="inspection.fk_id_inspection_state === 6"
                                                   #start_hour="ngModel">
                                            <i class="fa fa-clock-o"></i>
                                            <div [hidden]="start_hour.valid || start_hour.pristine"
                                                 class="form-error valid">
                                                Inserisci correttamente l'orario.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="end_hour" class="col-sm-4 control-label">Ora Fine Ispezione *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="end_hour"
                                                   name="end_hour"
                                                   class="form-control"
                                                   placeholder="Inserisci Ora Fine Ispezione..."
                                                   minlength="4"
                                                   required
                                                   autocomplete="off"
                                                   [ngClass]="{
                                            'form-error': !(end_hour.valid || end_hour.pristine),
                                            'form-success': end_hour.valid
                                       }"
                                                   [(ngModel)]="inspection.end_hour"
                                                   [disabled]="inspection.fk_id_inspection_state === 6"
                                                   #end_hour="ngModel">
                                            <i class="fa fa-clock-o"></i>
                                            <div [hidden]="end_hour.valid || end_hour.pristine"
                                                 class="form-error valid">
                                                Inserisci correttamente l'orario.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="panel">
                                <div class="panel-header bg-dark">
                                    <span style="text-transform: uppercase;"><i class="fa fa-briefcase"></i>Dettagli <strong>Ispettore Responsabile</strong></span>
                                </div>
                                <div class="panel-content">
                                    <div class="form-group">
                                        <label for="inspector_name" class="col-sm-4 control-label">Nome *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="inspector_name"
                                                   name="inspector_name"
                                                   class="form-control-plaintext"
                                                   [value]="inspection.inspector_name">
                                            <i class="icon-user"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="inspector_name" class="col-sm-4 control-label">Cognome *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="inspector_surname"
                                                   name="inspector_surname"
                                                   class="form-control-plaintext"
                                                   [value]="inspection.inspector_surname">
                                            <i class="icon-user"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="panel">
                                <div class="panel-header bg-dark">
                                    <span style="text-transform: uppercase;"><i class="fa fa-briefcase"></i>Dettagli <strong>Referente Ente</strong></span>
                                </div>
                                <div class="panel-content">
                                    <div class="form-group">
                                        <label for="referent_name" class="col-sm-4 control-label">Nome *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="referent_name"
                                                   name="referent_name"
                                                   class="form-control"
                                                   placeholder="Inserisci Nome Referente Ente..."
                                                   minlength="3"
                                                   required
                                                   autocomplete="off"
                                                   [ngClass]="{
                                            'form-error': !(referent_name.valid || referent_name.pristine),
                                            'form-success': referent_name.valid
                                       }"
                                                   [(ngModel)]="inspection.referent_name"
                                                   [disabled]="inspection.fk_id_inspection_state === 6"
                                                   #referent_name="ngModel">
                                            <i class="icon-user"></i>
                                            <div [hidden]="referent_name.valid || referent_name.pristine"
                                                 class="form-error valid">
                                                Inserisci almeno 3 caratteri.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="referent_surname" class="col-sm-4 control-label">Cognome *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="referent_surname"
                                                   name="referent_surname"
                                                   class="form-control"
                                                   placeholder="Inserisci Cognome Referente Ente..."
                                                   minlength="2"
                                                   required
                                                   autocomplete="off"
                                                   [ngClass]="{
                                            'form-error': !(referent_surname.valid || referent_surname.pristine),
                                            'form-success': referent_surname.valid
                                       }"
                                                   [(ngModel)]="inspection.referent_surname"
                                                   [disabled]="inspection.fk_id_inspection_state === 6"
                                                   #referent_surname="ngModel">
                                            <i class="icon-user"></i>
                                            <div [hidden]="referent_surname.valid || referent_surname.pristine"
                                                 class="form-error valid">
                                                Inserisci almeno 2 caratteri.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="referent_function" class="col-sm-4 control-label">Funzione *</label>
                                        <div class="col-sm-8 prepend-icon">
                                            <input type="text"
                                                   id="referent_function"
                                                   name="referent_function"
                                                   class="form-control"
                                                   placeholder="Inserisci Funzione Referente Ente..."
                                                   minlength="3"
                                                   required
                                                   autocomplete="off"
                                                   [ngClass]="{
                                            'form-error': !(referent_function.valid || referent_function.pristine),
                                            'form-success': referent_function.valid
                                       }"
                                                   [(ngModel)]="inspection.referent_function"
                                                   [disabled]="inspection.fk_id_inspection_state === 6"
                                                   #referent_function="ngModel">
                                            <i class="fa fa-briefcase"></i>
                                            <div [hidden]="referent_function.valid || referent_function.pristine"
                                                 class="form-error valid">
                                                Inserisci almeno 3 caratteri.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div *ngFor="let inspectionOrder of inspectionOrders" class="row">
                    <div class="col-md-12">
                        <div class="panel">
                            <div class="panel-header bg-dark">
                                <span style="text-transform: uppercase;"><i class="fa fa-briefcase"></i>Ordinativo <strong>{{ inspectionOrder.number }}</strong></span>
                            </div>
                            <div class="panel-content">
                                <div class="row">
                                    <div class="col-md-8 offset-md-2" style="margin-bottom: 20px;">
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                            <tr>
                                                <th [colSpan]="checklistSubCategories.length + 1" style="background-color: lightblue;">
                                                    <div>Prospetto Punteggi MacroCategorie</div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style="width: 70%; text-transform: uppercase;">Macrocategoria</th>
                                                <th style="width: 30%; text-transform: uppercase; text-align: center;">Punteggio</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let checklistCategory of checklistCategories">
                                                <td>{{ checklistCategory.code + ') ' + checklistCategory.name }}</td>
                                                <td style="text-align: center;">{{ checklistVotesMeanByCategory[inspectionOrder.id_inspection_order!][checklistCategory.id_checklist_category!] }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="col-md-12 table-responsive">
                                        <table class="table table-bordered table-hover">
                                            <thead>
                                            <tr>
                                                <th [colSpan]="checklistSubCategories.length + 1" style="background-color: lightblue;">
                                                    <div>Prospetto Punteggi Requisiti</div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th style="width: 20%;">Richiesta di Consegna</th>
                                                <th *ngFor="let checklistSubCategory of checklistSubCategories">{{ checklistSubCategory.checklist_category.code + checklistSubCategory.code}}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr *ngFor="let inspectionDeliveryRequest of inspectionDeliveryRequestsByOrder[inspectionOrder.id_inspection_order!]">
                                                <td style="min-width: 300px;">{{ inspectionDeliveryRequest.code }}</td>
                                                <td *ngFor="let checklistSubCategory of checklistSubCategories" style="min-width: 90px;">
                                                    <select class="form-control"
                                                            style="width: 100%;"
                                                            required
                                                            [disabled]="inspection.fk_id_inspection_state === 6"
                                                            [(ngModel)]="this.checklistVotes[inspectionOrder.id_inspection_order!][inspectionDeliveryRequest.id_inspection_delivery_request!][checklistSubCategory.id_checklist_subcategory!]['vote']">
                                                        <option selected>NA</option>
                                                        <option>1</option>
                                                        <option>2</option>
                                                        <option>3</option>
                                                        <option>4</option>
                                                        <option>5</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-md-12" style="margin-top: 10px; margin-bottom: 10px;">
                                        <div class="col-md-12 form-group">
                                            <label for="non-compliance" class="control-label">Non Conformità</label>
                                            <textarea type="text"
                                                      id="non-compliance"
                                                      name="non-compliance"
                                                      class="form-control"
                                                      rows="6"
                                                      autocomplete="off"
                                                      [disabled]="inspection.fk_id_inspection_state === 6"
                                                      [(ngModel)]="inspectionOrder.non_compliance">
                            </textarea>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label for="report" class="control-label">Osservazioni</label>
                                            <textarea type="text"
                                                      id="report"
                                                      name="report"
                                                      class="form-control"
                                                      rows="6"
                                                      autocomplete="off"
                                                      [disabled]="inspection.fk_id_inspection_state === 6"
                                                      [(ngModel)]="inspectionOrder.inspector_report">
                            </textarea>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label for="penalties" class="control-label">Penali</label>
                                            <textarea type="text"
                                                      id="penalties"
                                                      name="penalties"
                                                      class="form-control"
                                                      rows="6"
                                                      autocomplete="off"
                                                      [disabled]="inspection.fk_id_inspection_state === 6"
                                                      [(ngModel)]="inspectionOrder.penalties">
                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div id="panel-documents" class="panel">
                            <div class="panel-header bg-dark">
                                <span style="text-transform: uppercase;"><i class="fa fa-file"></i><strong>Documenti</strong></span>
                            </div>
                            <div class="panel-content table-responsive">
                                <table *ngIf="inspectionDocuments.length > 0" class="table table-hover">
                                    <thead>
                                    <tr>
                                        <th style="width: 85%;">Nome</th>
                                        <th style="width: 15%;">Azioni</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let inspectionDocument of inspectionDocuments">
                                        <td>{{ inspectionDocument.name }}</td>
                                        <td>
                                            <a class="edit btn btn-sm btn-primary"
                                               (click)="downloadInspectionDocument(inspectionDocument)"
                                               mat-raised-button
                                               matTooltip="Download"
                                               matTooltipPosition="above">
                                                <i class="fa fa-download"></i>
                                            </a>
                                            <a *ngIf="user.fk_id_role <= 1" class="delete btn btn-sm btn-danger"
                                               (click)="openDeleteInspectionDocumentModal(inspectionDocument)"
                                               mat-raised-button
                                               matTooltip="Elimina"
                                               matTooltipPosition="above">
                                                <i class="icons-office-57"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div *ngIf="inspectionDocuments.length === 0" style="text-align: center; height: 100px; padding-top: 35px;">
                                    Nessun documento caricato
                                </div>
                            </div>
                            <div *ngIf="user.fk_id_role === 1 || user.fk_id_role === 3" class="panel-footer" style="text-align: center;">
                                <a class="btn btn-sm btn-success" (click)="openUploadInspectionDocumentModal()">
                                    <i class="icon-plus"></i> Carica Documento</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-footer">
                <button *ngIf="inspection.fk_id_inspection_state <= 5"
                        class="btn btn-embossed btn-primary"
                        [disabled]="!inspectionValidationForm.form.valid || !isButtonEnabled"
                        (click)="saveChecklistVotes()">
                    <i class="glyphicon glyphicon-floppy-disk"></i> Salva Rapporto
                </button>
                <button *ngIf="user.fk_id_role === 1 && (inspection.fk_id_inspection_state === 4 || inspection.fk_id_inspection_state === 5)"
                        class="btn btn-embossed btn-success"
                        (click)="validateChecklist()">
                    <i class="fa fa-check-square"></i> Valida
                </button>
                <button *ngIf="user.fk_id_role <= 3 && (inspection.fk_id_inspection_state === 4 ||
                            inspection.fk_id_inspection_state === 5 || inspection.fk_id_inspection_state === 6)"
                        class="btn btn-embossed btn-warning"
                        (click)="generateReport()">
                    <i class="fa fa-download"></i> Genera PDF Report
                </button>
                <a [routerLink]="['/inspection']" class="btn btn-embossed btn-default">
                    <i class="fa fa-arrow-left"></i> Torna a Elenco
                </a>
            </div>
        </div>
    </div>
</div>
